<template>
  <div class="app">
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-row>
        <v-col cols="2">
          <v-skeleton-loader class="mx-auto" type="button" />
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="item in 3" :key="item">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
    </v-sheet>
    <v-form ref="form" v-show="!showSkeleton">
      <v-row>
        <v-col cols="1">
          <v-switch dense v-model="form.active" label="Ativo" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-select
            dense
            v-model="form.backup_total"
            :error-messages="backupErrors"
            :items="opcoes"
            label="Escolha uma opção de backup"
            @change="getOpc(form.backup_total)"
            @input="$v.form.backup_total.$touch()"
            @blur="$v.form.backup_total.$touch()"
          />
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { validateData, validateComputed } from '../_validates/validateBackup'

export default {
  name: 'LogarAgente',
  props: {
    acao: Object,
  },
  mixins: [validationMixin],

  data: () => ({
    form: {
      active: true,
      description: 'LOGAR AGENTE',
      tipo: 'backup',
      backup_total: '',
      backup_opc: '',
    },
    opcoes: [
      {
        text: 'Realizar backup completo',
        value: true,
      },
      {
        text: 'Realizar backup parcial',
        value: false,
      },
    ],
    showSkeleton: true,
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...validateComputed,
  },

  async created() {
    this.form = Object.assign({}, this.acao)
    this.showSkeleton = false
  },

  methods: {
    getOpc(valor) {
      if (valor) {
        this.form.backup_opc = 'Realizar backup completo'
      } else {
        this.form.backup_opc = 'Realizar backup parcial'
      }
    },
  },

  watch: {
    form: {
      deep: true,
      handler(novo) {
        this.$emit('form', novo)
        this.$emit('error', this.$v)
      },
    },
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
